import React, { useState } from 'react';
import { Menu, Typography } from '@material-ui/core';
import { Delete, Edit, MoreVert } from '@material-ui/icons';
import { Grid, MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { EditAssignmentPopup } from './EditAssignmentPopup';
import ConfirmationDialog from '../common/ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import { getTopicOfTheMonth, showProgress } from '../../redux/actions/DealershipActions';

const topicOfTheMonthDealershipColumns = [
  {
    accessorKey: 'id',
    header: 'ID',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 5,
    maxSize: 10,
    size: 5,
  },
  {
    accessorKey: 'startDate',
    header: 'Start Date',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 50,
    maxSize: 100,
    size: 50,
  },
  {
    accessorKey: 'endDate',
    header: 'End Date',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 50,
    maxSize: 100,
    size: 50,
  },
  {
    accessorKey: 'name',
    header: 'Dealership Name',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 100,
    maxSize: 200,
    size: 150,
  },
  {
    accessorKey: 'department',
    header: 'Department',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 50,
    maxSize: 300,
    size: 50,
  },
  {
    accessorKey: 'completion',
    header: 'Completion',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 10,
    maxSize: 20,
    size: 10,
  },
  {
    accessorKey: 'assignedOn',
    header: 'Assigned On',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 50,
    maxSize: 100,
    size: 50,
  },
  {
    accessorKey: 'assignedBy',
    header: 'Assigned By',
    Cell: ({ cell }) => <Typography noWrap>{cell.getValue()} </Typography>,
    minSize: 100,
    maxSize: 300,
    size: 150,
  },
  {
    accessorKey: 'dealershipTopicId',
    header: '',
    Cell: ({ cell }) => {
      const [anchorEl, setAnchorEl] = useState(null);
      const [isOpenPopup, setIsOpenPopup] = useState(false);
      const [isOpenDialog, setIsOpenDialog] = useState(false);
      const dealershipTopicId = cell.getValue();

      const topicOfTheMonthDate = useSelector((state) => state.getTopicOfTheMonth.selectedDate);
      const topicOfTheMonthSelectedId = useSelector((state) => state.getTopicOfTheMonth.selectedTopicId);

      const { name, startDate, endDate, id, departmentRoleIds } = cell?.row?.original || {};

      const dispatch = useDispatch();

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };

      const handleOpenPopup = () => {
        setIsOpenPopup(true);
        setAnchorEl(false);
      };

      const handleOpenDialog = () => {
        setIsOpenDialog(true);
        setAnchorEl(false);
      };

      const handleEndDate = async () => {
        dispatch(showProgress(true));
        const payload = {
          ids: dealershipTopicId,
          dealershipId: id,
          departmentRoleIds,
        };
        try {
          await service.post(apiEndpoints.TOM_END_ASSIGNMENT, payload);
          notifySuccess('Assignment ended successfully');
          fetchTopicDealershipList(topicOfTheMonthSelectedId.toString(), topicOfTheMonthDate.date);
          setIsOpenDialog(false);
        } catch (error) {
          ErrorToast(error);
        }
        dispatch(showProgress(false));
      };

      const fetchTopicDealershipList = async (topicId, topicDate) => {
        dispatch(showProgress(true));
        try {
          const response = await service.post(apiEndpoints.TOM_TABLE, {
            date: topicDate,
            topicIds: topicId,
          });
          dispatch(getTopicOfTheMonth('SET_TOPIC_DATA', response));
        } catch (err) {
          ErrorToast(err);
        }
        dispatch(showProgress(false));
      };

      return (
        <div>
          <Grid onClick={handleClick}>
            <MoreVert style={{ cursor: 'pointer' }} />
          </Grid>
          <Menu
            id="simple-menu"
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleOpenPopup} style={{ justifyContent: 'left', gap: '5px' }}>
              <Edit /> Edit Assignment
            </MenuItem>
            <MenuItem onClick={handleOpenDialog} style={{ justifyContent: 'left', gap: '5px' }}>
              <Delete /> End Assignment
            </MenuItem>
          </Menu>

          {isOpenPopup && (
            <EditAssignmentPopup
              isOpen={isOpenPopup}
              setIsOpen={setIsOpenPopup}
              dealerName={name}
              id={dealershipTopicId}
              startDate={startDate}
              endDate={endDate}
              fetchTopicDealershipList={fetchTopicDealershipList}
              dealershipId={id}
              departmentRoleIds={departmentRoleIds}
            />
          )}
          <ConfirmationDialog
            title="Are you sure you want to end this Assignment?"
            subText="Once you end it, the end date will change to yesterday."
            onClose={setIsOpenDialog}
            isOpen={isOpenDialog}
            confirmFn={handleEndDate}
            disagreeText="Cancel"
            agreeText="End Assignment"
            Icon={DeleteIcon}
            width="510px"
            height="250px"
          />
        </div>
      );
    },
    minSize: 50,
    maxSize: 50,
    size: 50,
  },
];

export default topicOfTheMonthDealershipColumns;
